"use client";
import React, { FC, ReactNode } from "react";
import Header from "./header/Header";
import { usePathname } from "next/navigation";
import Footer from "./footer/Footer";
// Sitewide pre-footer CTA temporarily disabled — most pages already
// carry their own Strapi-driven mid-page CTA (call-cta-section), and
// stacking a second one before the footer was diluting conversion.
// Re-enable by un-commenting the import + the render line below.
// import PreFooterCta from "./PreFooterCta";

type IPageLayoutProps = {
  children: ReactNode;
};

const PageLayout: FC<IPageLayoutProps> = (props) => {
  const { children } = props;

  const path = usePathname();

  // We didn't want header footer in some of the pages like thank you, courses, nirav-goti and yash-goti page

  if (
    path === "/thank-you" ||
    path.split("/")[1] === "courses" ||
    path === "/nirav-goti" ||
    path === "/yash-goti"
  ) {
    return <main>{children}</main>;
  }

  // Previously gated PreFooterCta off blog detail pages. With the CTA
  // disabled sitewide this check is moot, but we keep the variable so a
  // future re-enable can plug straight back into the {!isBlogDetail &&}
  // render below.
  void path;

  return (
    <>
      <Header />
      <main>{children}</main>
      {/* {!isBlogDetail && <PreFooterCta />} */}
      <Footer />
    </>
  );
};

export default PageLayout;
